import { constructLanguageUrl } from '@/router';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';

export function CoachLayout() {
  const { i18n } = useTranslation();
  const { lang } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  // Initialize language based on URL
  useEffect(() => {
    if (lang && lang !== i18n.language) {
      i18n.changeLanguage(lang);
      console.log('changeLanguage to', lang, 'from', i18n.language);
    }
  }, [lang, i18n]);

  console.log('CoachLayout', lang, i18n.language);

  console.log('Current language:', i18n.language);
  console.log('Loaded translations:', i18n.store.data);

  // Handle language changes and update URL
  useEffect(() => {
    const handleLanguageChange = (newLang: string) => {
      // Preserve current path (minus language prefix) and query parameters
      const queryParams = location.search;
      const currentPath = location.pathname;
      const newPath = constructLanguageUrl(newLang, currentPath, queryParams);
      console.log('handleLanguageChange', newPath);

      navigate(newPath, {
        // Preserve the current location state if any
        state: location.state,
      });
    };

    i18n.on('languageChanged', handleLanguageChange);
    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [navigate, location]);

  return (
    // <div className="min-h-screen bg-[#FAFAFA]">
    //   <header className="bg-white border-b border-gray-200 px-4 py-4">
    //     <div className="max-w-7xl mx-auto flex items-center justify-between">
    //       <img
    //         src="https://coach.hupo.co/logos/trademarked/orange/logo.svg"
    //         alt="Hupo AI"
    //         className="h-8"
    //       />
    //       <div className="flex gap-4">
    //         {supportedLanguagesList.map((code) => (
    //           <button
    //             key={code}
    //             onClick={() => i18n.changeLanguage(code)}
    //             className={`px-3 py-1 rounded-md ${
    //               code === i18n.language
    //                 ? 'bg-primary text-white'
    //                 : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
    //             }`}
    //           >
    //             {code.toUpperCase()}
    //           </button>
    //         ))}
    //       </div>
    //     </div>
    //   </header>
    //   <Outlet />
    // </div>
    <div>
      <Outlet />
    </div>
  );
}
